module.exports = __webpack_public_path__ + "static/media/feature2screening.b65f6ca6.png";